export function getResultsPage(items, page, perPage) {
    const start = (page - 1) * perPage;
    const end = page * perPage;
    return items.slice(start, end);
}

export function filterItems(items, filters) {
    let matchingItems = [...items];

    for (const [key, value] of Object.entries(filters)) {
        if (!value) {
            continue;
        }

        if (Number.isInteger(Number(key))) {
            matchingItems = matchingItems.filter((item) => {
                const fieldValue = item.history?.[key] ?? '';
                return fieldValue.toUpperCase().includes(value.toUpperCase());
            });
        } else {
            matchingItems = matchingItems.filter((item) => {
                const fieldValue = item[key] ?? '';
                return fieldValue.toUpperCase().includes(value.toUpperCase());
            });
        }
    }

    return matchingItems;
}
